import React from 'react'

class CloudwaysFooter extends React.Component {
	render() {
		return <div className="alert cws-footer">
			<div className="container">
				<span>© 2011-2020 Cloudways Ltd. All rights reserved</span>
			</div>
		</div> 
	}         
}           

export default CloudwaysFooter
